import { Link } from "react-router-dom";

export default function LegalLayout({ title, subtitle, children }) {
  return (
    <div className="min-h-screen bg-[#FDFCF8] text-[#1C1C1C]">
      <header className="border-b border-[#E5E5E5] bg-white">
        <div className="max-w-3xl mx-auto px-6 py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 rounded-md bg-[#2F4F4F] flex items-center justify-center text-[#FDFCF8] font-display font-bold">P</div>
            <div className="font-display font-semibold text-lg">Accountrix</div>
          </Link>
          <div className="flex gap-4 text-sm">
            <Link to="/privacy" className="text-[#5C5C5C] hover:text-[#2F4F4F]">Privacy</Link>
            <Link to="/terms" className="text-[#5C5C5C] hover:text-[#2F4F4F]">Terms</Link>
            <Link to="/login" className="text-[#2F4F4F] font-medium underline underline-offset-4">Back to app</Link>
          </div>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-6 py-12">
        <div className="text-xs tracking-[0.2em] uppercase text-[#5C5C5C]">Legal</div>
        <h1 className="font-display text-4xl mt-2">{title}</h1>
        <p className="text-sm text-[#5C5C5C] mt-2">{subtitle}</p>
        <div className="prose prose-sm max-w-none mt-8 leading-relaxed text-[#1C1C1C] [&_h2]:font-display [&_h2]:text-xl [&_h2]:mt-8 [&_h2]:mb-3 [&_h3]:font-display [&_h3]:text-base [&_h3]:mt-5 [&_h3]:mb-2 [&_p]:my-3 [&_ul]:my-3 [&_ul]:pl-5 [&_li]:my-1 [&_a]:text-[#2F4F4F] [&_a]:underline">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-[#E5E5E5] text-xs text-[#5C5C5C]">
          © {new Date().getFullYear()} Accountrix. Questions? Contact us via the email associated with your account.
        </div>
      </main>
    </div>
  );
}
